import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "@shared/widgets/register";
import * as QueriesQL from "queries/workflow";

// Hoisted out of the component: a config literal is a new object every render,
// and the form's provider rebuilds its widget tree when that identity changes —
// which detaches the control being typed into. See the note in ../workflow/edit.
const CREATE_FIELDS = {
  "/Public/Workflow/Create": {
    fields: [
      "workflowId",
      "title",
      "tags",
    ],
  },
};

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Create</BreadcrumbItem>;

export const Content = ({ history }) => {
  const { base } = useSectionContext();
  const initial = {
    workflowId: "",
    title: "",
    tags: [],
  };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/Workflow/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update({})}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { input } });
      }}
      onCompleted={(data) => {
        // `data` directly, not `{ data }`. Section's Mutation forwards Apollo's
        // onCompleted argument as-is, and Apollo passes the data object — so
        // destructuring a `data` key off it yields undefined and the redirect
        // silently falls back to the list, which is exactly the screen this
        // exists to skip.
        //
        // Straight into the editor because a workflow created here has no
        // steps by construction: the form asks for a name and a title and
        // nothing else, so the list would show a row there is no reason to
        // look at and the next click is always the same one.
        const created = data && data.viewer.account.workflows.create;

        history.replace(created ? `${base}/${created.workflowId}/edit` : base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: CREATE_FIELDS,
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Create</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
